/* eslint-disable jsx-a11y/media-has-caption */
import { Box, BoxProps } from "@mui/material";
import React from "react";
import videojs from "video.js";
import Player from "video.js/dist/types/player";
import { CameraItemDto } from "~/api/GeneratedApi";
import { API_BASE_URL } from "~/config";
import { useAccess } from "~/utils/hooks/useAccess";

type Props = {
  camera: CameraItemDto;
  containerProps?: BoxProps;
  height?: number;
  width?: number;
};

export const CameraVideo = ({
  camera,
  containerProps,
  height,
  width,
}: Props): JSX.Element | null => {
  const videoRef = React.useRef<HTMLVideoElement | null>(null);
  const playerRef = React.useRef<Player | null>(null);
  const { CameraStream } = useAccess();

  React.useEffect(() => {
    const source = {
      src: `${API_BASE_URL}/api/Camera/${camera.id}/LiveHlsStream`,
      type: "application/x-mpegURL",
    };
    // Make sure Video.js player is only initialized once
    if (!playerRef.current) {
      const videoElement = videoRef.current;
      if (!videoElement || !CameraStream) return;

      playerRef.current = videojs(
        videoElement,
        {
          sources: [source],
          liveui: true,
          fluid: true,
          height,
          width,
        },
        () => {
          // console.log("player is ready");
        },
      );
      // You could update an existing player in the `else` block here
      // on prop change, for example:
    } else {
      // const player = playerRef.current;
      // player.autoplay(options.autoplay);
      // player.src(options.sources);
      playerRef.current.src(source);
    }
  }, [CameraStream, camera.id, camera.streamUrl, height, width]);

  // Dispose the Video.js player when the functional component unmounts
  React.useEffect(() => {
    return () => {
      if (playerRef.current) {
        playerRef.current.dispose();
        playerRef.current = null;
      }
    };
  }, []);

  if (!CameraStream) return null;

  return (
    <Box {...containerProps}>
      <video
        ref={videoRef}
        className="video-js vjs-default-skin"
        controls
        preload="auto"
        autoPlay
      />
    </Box>
  );
};
